import React, { Component, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { EnrollmentService } from 'gw-capability-policyenrollment';
import AccountDropDownValuesMessages from './AccountDropDownValues.messages';

export const ProducerContext = React.createContext({
    producerCode: 'all',
    setProducerCode: () => {},
    
});
class AccountDropDownValuesContextProvider extends Component {
    static propTypes = {
        children: PropTypes.shape({}).isRequired,
        authHeader: PropTypes.shape({}).isRequired
    };

    state = {
        producerCodeList: [],
        unSortedProducerCodeList: [],
        producerCode: 'all',
        setProducerCode: (producerCode) => {
            this.setState({ producerCode });
        },
        multiInvoiceDropDown:'',
        setMultiInvoiceDropDown:(multiInvoiceDropDown)=>{
            this.setState({ multiInvoiceDropDown });
        }
    };

    componentDidMount() {
        this.getProducerCode();
    }

    getProducerCode = async () => {
        const { authHeader } = this.props;
        const availableProducerCode=[];
        const userInfo= await EnrollmentService.getUser(this.props.userInfo.email,authHeader)
            .then((responseObject)=>{
                // // Logic for invoiceStreams Access
                // // eslint-disable-next-line react-hooks/exhaustive-deps, no-const-assign
                // for(let i = 0;i < responseObject.accountInformation.length; i ++)
                // {
                //     const b =[];
                //     const result  =responseObject.roles.filter((o)=>o.access === responseObject.accountInformation[i].accountNumber);
                //     if(result !==undefined){
                //         const streamResult = result.reduce((catsSoFar, { access, description }) => {
                //             if (!catsSoFar[access]) catsSoFar[access] = [];
                //             catsSoFar[access].push(description);
                //             return catsSoFar;
                //         }, {});
                //         const gArray = Object.entries(streamResult);
                //         console.log(streamResult)
                    
                //         // eslint-disable-next-line array-callback-return
                //         responseObject?.accountInformation[i]?.invoiceStreams.map((k)=>{
                //             const v =k.replace(/\s/g, '');
                //             const resultFilter = gArray[0][1].includes(v);
                //             if(resultFilter===false){
                //                 delete responseObject?.accountInformation[i]?.invoiceStreams[k]  
                //             }else{ 
                //                 b.push(k);  
                //             }
                //         })   
                //     }
                //     responseObject.accountInformation[i].invoiceStreams =[];
                //     responseObject.accountInformation[i].invoiceStreams = b;
                // }
                
                // console.log(responseObject);
                // Logic for invoiceStreams Access
                // eslint-disable-next-line array-callback-return
                responseObject.accountInformation.map((listItem)=>{
                    availableProducerCode.push({code:listItem.accountNumber,name:`${listItem.accountNumber  } ${' '} ${  listItem.accountName}`})  
                })
            })
        
        const producerCodeList = availableProducerCode.sort((a, b) => {
            return a.code - b.code;
        });
        
        this.setState({ producerCodeList, unSortedProducerCodeList: availableProducerCode });
    };

    render() {
        const { children } = this.props;
        const {
            unSortedProducerCodeList,
            producerCodeList,
            producerCode,
            setProducerCode,
            multiInvoiceDropDown,
            setMultiInvoiceDropDown
        } = this.state;
        return (
            <ProducerContext.Provider
                value={{
                    unSortedProducerCodeList,
                    producerCodeList,
                    producerCode,
                    setProducerCode,
                    multiInvoiceDropDown,
                    setMultiInvoiceDropDown
                }}
            >
                {children}
            </ProducerContext.Provider>
        );
    }
}

function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}
export function withProducerContext(WrappedComponent) {
    function WithProducerContext(props) {
        const producerProps = useContext(ProducerContext);
        return <WrappedComponent {...producerProps} {...props} />;
    }
    hoistNonReactStatic(WithProducerContext, WrappedComponent);
    WithProducerContext.displayName = `WithProducerContext(${getDisplayName(WrappedComponent)})`;
    return WithProducerContext;
}
export const AccountDropDownContextProvider = withAuthenticationContext(
    AccountDropDownValuesContextProvider
);
export default ProducerContext.Consumer;
